/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FunnelStatusFollowUpInstruction = {
    type: FunnelStatusFollowUpInstruction.type;
    text: string;
};
export namespace FunnelStatusFollowUpInstruction {
    export enum type {
        FOLLOW_UP = 'followUp',
    }
}

